import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { Site } from '@swf/core/enums';
import useTrackers from '@swf/core/hooks/useTrackers';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import type { CasinoGame, CasinoTable } from '@swf/core/types/CasinoGame';

import { TXTCLI_Play, TXTWCL_Join } from './InfoPlayButton.messages.json';

interface Props {
  className?: string;
  isModal?: boolean;
  fsbLaunch?: boolean;
  raceId?: string;
  game: CasinoGame;
}

const InfoPlayButton: React.FC<Props> = (props) => {
  const siteId = useSelector(select.cms.getSiteId);
  const { modal } = useDispatch<Dispatch>();
  const { casinoGameLaunched } = useTrackers();
  const {
    casino: { launch }
  } = useDispatch<Dispatch>();
  const { className, fsbLaunch, game, raceId } = props;
  const [{ id, playMoney }] = game.tables;

  const onPlayClickHandler = () => {
    modal.close('/casino/game-info');
    launch({ table: { id, playMoney } as CasinoTable, fsbLaunch, raceId, game });
    game && casinoGameLaunched({ game });
  };

  return (
    <StarsButton
      className={className}
      onClick={() => onPlayClickHandler()}
      translation={siteId === Site.GR ? TXTWCL_Join : TXTCLI_Play}
    />
  );
};

export default InfoPlayButton;
